import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Answer } from '@digilize/shared/definitions/src';

@Component({
  selector: 'lib-multiple-radio-inputs',
  templateUrl: './multiple-radio-inputs.component.html',
  styleUrls: ['./multiple-radio-inputs.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MultipleRadioInputsComponent implements OnInit {
  @Input() formGroup: FormGroup = new FormGroup({ mockControl1: new FormControl(), mockControl2: new FormControl() });
  @Input() questions: Question[];
  @Input() withInnerHTML = false;
  constructor() {}

  ngOnInit(): void {}
}
export interface Question {
  question: string;
  answers: Answer[];
  formControlName: string;
}
